import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, Self, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { ITableModel } from '../table/model/tableModel';
import { Http } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../../app/_services/app.service';
import { CommonService } from '../../../../app/_services/common.service';
import { DecryptPipe } from '../../../../app/auth/_services/encrypt-decrypt.pipe';
import { Helpers } from '../../../../app/helpers';
import { TranslateConfigService } from '../../../../app/theme/home/translateConfig.service';
import { MobileDetectionService } from '../../services/mobile-detection.service';
import { OrdersService } from '../../services/orders/orders.service';
import { MarkerClusterer, SuperClusterAlgorithm } from '@googlemaps/markerclusterer';
import { environment } from '../../../../environments/environment';
import { DatePipe } from '@angular/common';
import { Observable } from 'rxjs';
declare var google: any;
const LNG_KEY = "SELECTED_LANGUAGE";
import * as L from 'leaflet';
import 'leaflet-routing-machine';

@Component({
  selector: 'app-self-fulfilled',
  templateUrl: './self-fulfilled.component.html',
  styleUrls: ['./self-fulfilled.component.scss']
})
export class SelfFulfilledComponent implements OnInit {

  TenantId: any;
  CompanyId: any;
  tableDetails: ITableModel;
  mapPickup: any;
  totalOrderCount: number = 0;
  filterObj: any = {
    vehicleStatus: ''
  };
  selectedLang: any;
  noOfPages: number = 15;
  userId: any;
  static that: SelfFulfilledComponent;
  @ViewChild("AssignVehicle") AssignVehicle: TemplateRef<any>;
  beachMarker: any;
  tableData: any = [];
  selectedRowId: any = null
  singleVehicle: any;
  VehicleDirectionDegree: any = 0;
  PickUpLatitude: any;
  PickUpLongtitude: any;
  DeliverLatitude: any;
  DeliverLongtitude: any;
  Origin: any;
  Destination: any;
  @Input() isSelfDDValue: boolean = false;
  @Input() selectedVehicleType: any;
  modalRef: any;
  TransportServiceList: any;
  TransationType: any;
  Id: any;
  bookingData: any = {};
  IsAssignvehicleSaveDisable: any = false;
  ValidateTHCADvanceAmountFlag: boolean = false;
  courierListIds: any = [];
  CourierList: any = [];
  ManualvehicleOrderList: any = [];
  ManualvehicleOrderDetail = [];
  ManualvehiclePlanning: any = {};
  isSTPBooking: any = false;
  ManualPlanningDestinationValuesFromPinCodeDeliveryBranchFlag = false;
  ordersData: any;
  CourierPackages: any = [];
  CourierDimentions: any = [];
  CourierAdditionalPack: any = [];
  TransportNames: any = [];
  OrderData: any = {};
  OrdersPackage: any = [];
  CourierRate: any = [];
  NetTotal: any = 0;
  TaxApplicableFlag: boolean = false;
  infoWindow: any;
  OwnershipType: any;
  isMobileView: boolean;
  @Input() TransportService: any;
  //added by vithu 03-04-2025
  ExpenseBifurcation: any = [];
  @ViewChild("ExpenseBifurcationComponent") ExpenseBifurcationComponent: TemplateRef<any>;
  @Output() dataAvailable = new EventEmitter<boolean>();
  @ViewChild('SelfFullfieldMap') mapContainerSelfFullfilled: ElementRef;
  private mapSelfFullfilled: L.Map | null = null;
  originIcon = L.icon({
    iconUrl: 'assets/img/leaflet/images/origin.png',
    iconSize: [24, 24],
    iconAnchor: [12, 12],       // Center of circle
    popupAnchor: [0, -12]       // Popup shows above center
  });
  destinationIcon = L.icon({
    iconUrl: 'assets/img/leaflet/images/destination.png',
    iconSize: [24, 24],
    iconAnchor: [12, 12],
    popupAnchor: [0, -12]
  });
  waypointIcon = L.icon({
    iconUrl: 'assets/img/truck_inactive.png',
    iconSize: [32, 32],
    iconAnchor: [16, 16],
    popupAnchor: [0, -16]
  });
  cfsIcon = L.icon({
    iconUrl: 'assets/img/leaflet/images/cfs.png',
    iconSize: [24, 24],
    iconAnchor: [12, 12],       // Center of circle
    popupAnchor: [0, -12]       // Popup shows above center
  });
  shipNowData: any = {};


  constructor(
    private router: Router,
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private translate: TranslateService,
    private commonService: CommonService,
    private service: TranslateConfigService,
    private mobileDetectionService: MobileDetectionService,
    private modalService: NgbModal,
    private orderService: OrdersService,
    private anghttp: Http,
    private route: ActivatedRoute,
    private dp: DatePipe
  ) {
    SelfFulfilledComponent.that = this;
    let language = this.translate.getBrowserLang();
    let value = localStorage.getItem(LNG_KEY);
    if (value === "" || value === null || value === undefined) {
      this.translate.setDefaultLang(language);
      this.selectedLang = language;
    } else {
      this.service.setLanguage(value);
      this.selectedLang = value;
    }
    let val = localStorage.getItem(LNG_KEY);
  }

  ngOnInit() {
    this.TenantId = JSON.parse(localStorage.getItem("ChnageCompnayId")).TenantId;
    this.decryptpipe.transform(JSON.parse(this.cookieService.get("TenantId")));
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    const storedPerPage = localStorage.getItem('perPage');
    if (storedPerPage) {
      this.noOfPages = parseInt(storedPerPage, 10);
    }
    let rowData = localStorage.getItem('RowData');
    if (rowData) {
      this.ordersData = JSON.parse(rowData);
    } else {
      console.error('No data found in localStorage for "RowData"');
    }
    this.ManualPlanningDestinationValuesFromPinCodeDeliveryBranchFlag =
      JSON.parse(
        localStorage.getItem(
          "ManualPlanningDestinationValuesFromPinCodeDeliveryBranchFlag"
        )
      );
    this.route.queryParamMap.subscribe((params) => {
      this.Id = params.get("id");
      this.TransationType = params.get("type");
      if (this.Id != null && this.Id != undefined && this.Id != "") {
        if (this.TransationType == 'FTL') {
          this.initiateCourierList(this.Id);
        }
        if (this.TransationType == 'ContainerMovement') {
          this.initiateCourierList(this.Id);
        }
        // if (this.TransationType == 'Country') {
        //   this.GetCourierRates();
        // }
        if (this.TransationType == 'Air') {
          this.initiateCourierList(this.Id);
        }
      }
    });
    this.FulfilledList();
    this.GetOrderList();
    this.GetTransportService();
    this.LoadValidateTHCADvanceAmount();
    this.isMobileView = this.mobileDetectionService.checkScreenSize();
    if (this.TransationType == 'ContainerMovement') {
      this.tableDetails.emptyDataMSg = 'No Vehicle Available'
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isMobileView = this.mobileDetectionService.checkScreenSize();
  }

  async FulfilledList() {
    this.tableDetails = {
      data: [],
      emptyDataMSg: 'No Data Found',
      columnDetails: [
        { columnName: '', dataFieldName: 'TypeNo', dataFieldName2: 'DriverName', dataFieldName3: 'TransporterName', dataFieldName4: 'LRNumber', dataFieldName5: 'DeliveryDetails', userIcon: 'VehicleImage', divType: 'UserDetails', isVehicle: true },
        { columnName: '', dataFieldName: "Rate", divType: "", },
        { columnName: '', dataFieldName: "Distance", divType: "distanceDetails", },
        { columnName: '', dataFieldName: "Status", divType: "ftlstatus", },
        { columnName: '', dataFieldName: 'MobileNo', divType: 'phoneIcon' },
        { columnName: '', dataFieldName: '', divType: 'NewShipAction' },
      ],
      actionList: [],
    };
  }

  GetOrderList(pageNo: number = 0, filterObject: any = this.filterObj, perPage: any = this.noOfPages, isFilter = false) {
    // 
    let vehicleStatus: any;
    let ownershipType: any;
    if (filterObject[1]) {
      vehicleStatus = filterObject[1].value
    }
    if (filterObject[0]) {
      ownershipType = filterObject[0].value
    }
    Helpers.setLoading(true);
    localStorage.setItem('perPage', perPage);
    var obj: any = {}
    obj.Start = (pageNo * perPage);
    obj.PerPage = perPage;
    obj.CompanyId = this.CompanyId;
    obj.userId = this.userId;
    obj.vehicleStatus = vehicleStatus || null,
      obj.OrderId = this.ordersData.Id
    obj.OwnershipType = ownershipType || null

    this._appService.Post("OrdersByVehicle", "Ftl_SelfFulfilled", obj).subscribe((response) => {
      response = response.map((item: any) => {
        return {
          ...item,
          VehicleImage: item.VehicleImage ? `${environment.apiUrl}${item.VehicleImage}` : '', // Add base URL
        };
      });
      if (response.length) {
        this.totalOrderCount = response[0].Count;
        this.tableData = response;
        this.dataAvailable.emit(true);
        this.shipNowData = this.tableData[0];
        this.FTLOrderListById(this.ordersData.Id);
      } else {
        this.dataAvailable.emit(false);
      }
      this.assignTableFields(pageNo, perPage, response);
      this.WayPoints = [];
      response.forEach(element => {
        if (element.lat != null && element.long != null) {
          // var obj: any = {};
          // obj.lat = element.lat;
          // obj.lng = element.long;
          // obj.VehicleNo = element.TypeNo;
          this.WayPoints.push(element);
        }
      });

      // setTimeout(() => {
      //   this.showOriginDestinationWayPoint();
      // }, 1000);
      Helpers.setLoading(false);
    },
      (err) => {
        Helpers.setLoading(false);
        this.dataAvailable.emit(false);
        this.toastr.error(
          this.translate.instant("User.ErrorMessage"),
          "error"
        );
      });
  }

  //added by vithu 30-07-2025
  selectedOrder: any = {};
  FTLOrderListById(Id: any) {
    this._appService.GetById("OrdersByVehicle", "FTLOrderListById", Id).subscribe(
      (response) => {
        this.selectedOrder = response[0];
      },
      (err) => {
        this.toastr.error(
          "Error occurred while fetching Courier data !",
          "error"
        );
      });
  }

  assignTableFields(pageNo, perPage, data) {
    this.tableDetails = {
      ...this.tableDetails, paginationDetails: {
        totalItems: this.totalOrderCount,
        itemsPerPage: perPage,
        currentPage: pageNo + 1
      },
      data: data
    }
  }

  initiateCourierList(data: any) {
    this.courierListIds = data;
    var obj: any = {};
    obj.OrderId = this.courierListIds;

    this._appService.Post("OrdersByVehicle", "oc_GetCourierDataByIds", obj).subscribe(
      (response) => {
        this.CourierList = response.Table;
        this.CourierPackages = response.Table1;
        this.CourierDimentions = response.Table2;
        this.CourierAdditionalPack = response.Table4;
        this.OrdersPackage = response.Table5;

        var TransportName: any = [];
        this.CourierList.forEach((element) => {
          TransportName.push(element.TransportName);
        });
        this.TransportNames = Array.from(new Set(TransportName)).join(", ");

        this.OrderData.OrderCount = this.courierListIds.length;
        this.OrderData.SumOfQty = 0;
        this.OrderData.SumOfWeight = 0;
        this.OrderData.Volume = 0;
        this.OrderData.SumOFCFT = 0;

        this.CourierDimentions.forEach((element) => {
          this.OrderData.SumOfQty = this.OrderData.SumOfQty + element.Qty;
        });
        this.CourierPackages.forEach((element) => {
          this.OrderData.SumOFCFT = this.OrderData.SumOFCFT + element.CFT;
          this.OrderData.SumOfWeight =
            this.OrderData.SumOfWeight + element.weight;
          this.OrderData.Volume = this.OrderData.Volume + element.Volume;
        });

        if (this.TransationType != 'Air') {
          this.GetCourierRate();
        } else {
          this.OrderData.SumOfQty = 0;
          this.OrderData.SumOfWeight = 0;
          this.OrderData.SumOfDimension = 0;
          this.OrdersPackage.forEach((element) => {
            this.OrderData.SumOfQty = this.OrderData.SumOfQty + element.TotalPackages;
            this.OrderData.SumOfWeight = this.OrderData.SumOfWeight + element.GrossWeight;
            this.OrderData.SumOfDimension = this.OrderData.SumOfDimension + (element.Length + element.Width);
          });
        }

      },
      (err) => {
        this.toastr.error(
          "Error occurred while fetching Courier data !",
          "error"
        );
      });
  }

  async GetCourierRate() {
    const hasComma = this.courierListIds.includes(",");

    var obj: any = [];
    if (hasComma == false) {
      obj.push(this.courierListIds);
    } else {
      obj = this.courierListIds.split(",").map((item) => item.trim());
    }

    for (let i = 0; i < obj.length; i++) {
      await new Promise(async (resolve1, reject1) => {
        this._appService
          .GetByTwoId(
            "OrdersByVehicle",
            "oc_GetCourierRate",
            obj[i],
            this.CompanyId
          )
          .subscribe(
            (response) => {
              this.CourierRate = [];
              this.CourierRate = response;
              var SubTotal = 0;
              var totalSGST = 0;
              var totalCGST = 0;
              var totalIGST = 0;
              this.NetTotal = 0;
              this.CourierRate.forEach((element) => {
                SubTotal = SubTotal + element.ChargeRate;
                totalSGST =
                  totalSGST + element.ChargeRate * (element.SGST / 100);
                totalCGST =
                  totalCGST + element.ChargeRate * (element.CGST / 100);
                totalIGST =
                  totalIGST + element.ChargeRate * (element.IGST / 100);
              });
              SubTotal = parseFloat(SubTotal.toFixed(2));
              totalSGST = parseFloat(totalSGST.toFixed(2));
              totalCGST = parseFloat(totalCGST.toFixed(2));
              totalIGST = parseFloat(totalIGST.toFixed(2));

              if (this.TaxApplicableFlag == false) {
                this.NetTotal = parseFloat(SubTotal.toFixed(2));
                totalSGST = 0;
                totalCGST = 0;
                totalIGST = 0;
              } else {
                this.NetTotal = parseFloat(
                  (SubTotal + totalSGST + totalCGST + totalIGST).toFixed(2)
                );
              }
              resolve1("OK");
            },
            (err) => {
              this.toastr.error(
                "Error occurred while fetching courier rate data !",
                "error"
              );
              resolve1("OK");
            }
          );
      });
    }
  }

  GetTransportService() {
    this.orderService.GetTransportServiceList().then((res) => {
      this.TransportServiceList = res;
    })
      .catch((error) => {
      });
  }

  goToDetailsPage = (event): void => {
    this.selectedRowId = event.id;
    this.openInfoWindowForVehicle(event.id);

    this.GetExpenseBifurcation(event.TransporterId);
  }

  onPageChange(pageNo: number) {
    const storedPerPage = localStorage.getItem('perPage') || this.noOfPages;
    this.GetOrderList(pageNo - 1, {}, storedPerPage);
  }

  onPageNumberChange(noOfPages: any) {
    localStorage.setItem('perPage', noOfPages);
    this.GetOrderList(0, {}, noOfPages);
  }

  LoadValidateTHCADvanceAmount() {
    this._appService.GetById("Common", "GetSystemSettingByName", "ValidateTHCADvanceAmount").subscribe(
      (response) => {
        if (response == "1") {
          this.ValidateTHCADvanceAmountFlag = true;
        } else {
          this.ValidateTHCADvanceAmountFlag = false;
        }
      },
      (err) => {
        this.toastr.error(
          "Error occurred while fetching Status data !",
          "error"
        );
      });
  }

  CreateConsignmentCountry(TransporterId, LeadTime) {
    Helpers.setLoading(true);
    this._appService.GetByEightId("OrdersByVehicle", "oc_ConfirmCourierData_generateInvoiceOrderWiseV2", this.Id, this.userId, TransporterId, LeadTime, '', '', '', 0).subscribe(
      (response) => {
        if (response[0].isDone == "OK") {
          this.toastr.success("Order Confirm successfully !", "Success");
          Helpers.setLoading(false);
          this.router.navigateByUrl("/NewBookingList");
        } else {
          this.toastr.error(
            "Error Occurred While ConFirm Booking !",
            "Error"
          );
          Helpers.setLoading(false);
        }
      },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error(err._body.replace(/"/g, ""), "Error");
      });
  }

  ShipActionBtn(event) {
    let pendingCount = 0;
    this._appService.GetById("OrdersByVehicle", "GetNewOrdersDetailList", this.Id).subscribe((res) => {
      pendingCount = res.Table[0].Pending;
      if (pendingCount <= 0) {
        this.toastr.warning('Transporter is allocated for this shipment', 'Warning')
        return
      } else {
        var difference = 0;
        if (this.TransationType == "FTL") {
          this.bookingData.VehicleType = event.row.VehicleTypeId
          this.bookingData.VehicleNo = event.row.RegistrationNo;
          this.bookingData.Transporter = event.row.TransporterId
          this.bookingData.TransporterName = event.row.TransporterName;
          this.bookingData.Driver = event.row.DriverName;
          this.bookingData.DriverName = event.row.Driver;
          this.bookingData.DriverCode = event.row.DriverCode;
          this.bookingData.DriverMobileNo = event.row.MobileNo;
          // commented and added by priya - 07/04/2026 - cn(PRIYA-APR26-002)
          // this.bookingData.TransportService = this.TransportServiceList.filter(
          //   (x) => x.Label === "FTL"
          // )[0].Id;
          let selectedService = this.TransportServiceList.find(
            (x: any) => x.Label === this.TransportService.TransportName
          );
          if (!selectedService) {
            selectedService = this.TransportServiceList.find((x: any) => x.Label === "FTL");
          }
          this.bookingData.TransportService = selectedService ? selectedService.Id : null;
          // end by priya
          this.bookingData.VehiclePlacementDate = this.dp.transform(new Date(), "dd-MMM-yyyy");
          this.bookingData.EstimatedDeliveryDate = this.dp.transform(new Date(), "dd-MMM-yyyy");
          this.bookingData.LeadTime = 0;
          this.bookingData.Advance = 0;
          //added by vithu 30-06-2025
          this.bookingData.DriverLicenseNo = event.row.DriverLicenseNo;
          this.bookingData.DriverDOB = event.row.DriverDOB ? this.dp.transform(new Date(event.row.DriverDOB), "dd-MMM-yyyy") : null;
          // Added by priya - 23/06/2026 - cn(PRIYA-JUN26-008)
          this.bookingData.VehicleDistance = event.row.VehicleDistance;
          this.bookingData.VehicleTravelTime = event.row.VehicleTravelTime;
          this.bookingData.OrderPickupDate = event.row.OrderPickupDate;
          // End by priya
        } else if (this.TransationType == 'ContainerMovement') {
          this.bookingData.VehicleType = event.row.VehicleTypeId;
          this.bookingData.VehicleNo = event.row.RegistrationNo;
          this.bookingData.Transporter = event.row.TransporterId
          this.bookingData.TransporterName = event.row.TransporterName;
          this.bookingData.Driver = event.row.DriverName;
          this.bookingData.DriverName = event.row.Driver;
          this.bookingData.DriverCode = event.row.DriverCode;
          this.bookingData.DriverMobileNo = event.row.MobileNo;
          let selectedService = this.TransportServiceList.find(
            (x: any) => x.Label === this.TransportService.TransportName
          );
          this.bookingData.TransportService = selectedService ? selectedService.Id : null;
          this.bookingData.VehiclePlacementDate = this.dp.transform(new Date(), "dd-MMM-yyyy");
          this.bookingData.EstimatedDeliveryDate = this.dp.transform(new Date(), "dd-MMM-yyyy");
          this.bookingData.LeadTime = 0;
          this.bookingData.Advance = 0;
          // Added by priya - 23/06/2026 - cn(PRIYA-JUN26-008)
          this.bookingData.VehicleDistance = event.row.VehicleDistance;
          this.bookingData.VehicleTravelTime = event.row.VehicleTravelTime;
          this.bookingData.OrderPickupDate = event.row.OrderPickupDate;
          // End by priya
        } else if (this.TransationType == 'Air') {
          this.OnClickShipNow(event.row.ShortName, event.row.TransporterId, event.row.Transporter, event.row.LeadTime, event.row.service_code, event.row.Rate);
        } else {
          if (difference < 0) {
            this.toastr.info("Please Recharge to Confirm Order", "Info");
          } else {
            this.CreateConsignmentCountry(event.row.id, event.row.LeadTime);
          }
        }
        this.modalRef = this.modalService.open(this.AssignVehicle, {windowClass: 'assign-vehicle-modal',centered: false});
      }
    });
  }

  async OnClickShipNow(ShortName, TransporterId, TransporterName, LeadTime, service_code, TotalRate) {
    // const hasComma = this.courierListIds.includes(",");
    // 
    // var obj: any;
    // if (hasComma == false) {
    //   obj = this.courierListIds;
    //   this.courierListIds = [];
    //   this.courierListIds.push(obj);
    // }
    for (let a = 0; a < this.courierListIds.length; a++) {
      await new Promise(async (resolve1, reject1) => {
        this._appService.GetById("OrdersByVehicle", "oc_GetCourierDataByIdConsignment", SelfFulfilledComponent.that.courierListIds[a]).subscribe(
          (response) => {
            var obj: any = {};
            obj.OrderDetails = response.Table[0];
            obj.ProductDetails = response.Table1;
            obj.ProductDimentions = response.Table2;
            obj.InvoiceDetails = response.Table3;
            obj.AdditionalServices = response.Table4;
            obj.OrdersPackage = response.Table5;

            var ConsignmentList: any = [];
            ConsignmentList.push(obj);
            SelfFulfilledComponent.that.CreateConsignment(
              obj,
              ShortName,
              SelfFulfilledComponent.that.courierListIds[a],
              TransporterId,
              TransporterName,
              LeadTime,
              service_code,
              TotalRate
            );
            resolve1("OK");
          },
          (err) => {
            this.toastr.error(
              "Error occurred while fetching data !",
              "error"
            );
            resolve1("OK");
          });
      });
    }
  }

  async CreateConsignment(
    a: any,
    TransporterShortName: any,
    OrderId: any,
    TransporterId: any,
    TransporterName: any,
    LeadTime: any,
    service_code: any,
    TotalRate: any
  ) {
    var data: any = {};

    data.consignment = {};
    data.consignment.consolidate = 'No'; //this.DiffLocations == true ? 'No' : 'Yes';
    data.consignment.shipper_company_code = a.OrderDetails.PickupLocationCode;
    data.consignment.consignment_number = '';
    data.consignment.is_draft = "No";
    data.consignment.from_challan_id = "";
    data.consignment.consignor_company_id = "";
    data.consignment.consignor_company_name = a.OrderDetails.ConsignorCompany;
    data.consignment.consignor_company_code = a.OrderDetails.ConsignorCode;
    data.consignment.consignor_facility_name = a.OrderDetails.PickupCity;
    data.consignment.consignor_facility_code = a.OrderDetails.PickupLocationCode;
    data.consignment.consignor_address_line1 = a.OrderDetails.ConsignerAddress;
    data.consignment.consignor_address_line2 = "";
    data.consignment.consignor_city = a.OrderDetails.ConsignerCity;
    data.consignment.consignor_state = a.OrderDetails.ConsignerState;
    data.consignment.consignor_pin = a.OrderDetails.ConsignerPincode;
    data.consignment.consignor_contact_name = a.OrderDetails.PickUpContactPerson;
    data.consignment.consignor_phone = a.OrderDetails.PickUpContactNumber;
    data.consignment.consignee_company_id = "";
    data.consignment.consignee_company_name = a.OrderDetails.ConsigneeName;
    data.consignment.consignee_company_code = a.OrderDetails.ConsigneeCode;
    data.consignment.consignee_facility_name = a.OrderDetails.DeliveryCity;
    data.consignment.consignee_facility_code = a.OrderDetails.DeliveryLocationCode;
    data.consignment.consignee_address_line1 = a.OrderDetails.ConsigneeAddress;
    data.consignment.consignee_address_line2 = "";
    data.consignment.consignee_city = a.OrderDetails.ConsigneeCity;
    data.consignment.consignee_state = a.OrderDetails.ConsigneeState;
    data.consignment.consignee_pin = a.OrderDetails.ConsigneePincode;
    data.consignment.consignee_contact_name = a.OrderDetails.DeliveryContactPerson;
    data.consignment.consignee_phone = a.OrderDetails.DeliveryContactNumber;
    data.consignment.reference_number_1 = a.OrderDetails.ReferenceNo;
    data.consignment.reference_number_2 = "";
    data.consignment.service_option = 'SURF XPRS'; //a.OrderDetails.TransportName;
    data.consignment.truck_category = "";
    data.consignment.service_provider_company_code = TransporterShortName;
    data.consignment.vehicle_number = "";
    data.consignment.driver_name = "";
    data.consignment.driver_mobile_number = "";
    data.consignment.volume = ""; //a.OrderDetails.Volume;
    data.consignment.volume_measure = "";
    data.consignment.ready_for_pickup_at = a.OrderDetails.PickupLocationCode;
    data.consignment.payment_mode = 'To Bill'; //a.OrderDetails.Freight;
    data.consignment.slot_date = "";
    data.consignment.slot_name = "";
    data.consignment.slot_company_code = "";
    data.consignment.weight = a.OrderDetails.Weight;
    data.consignment.billable_weight = a.OrderDetails.VolumetricWeight > a.OrderDetails.Weight == true ? a.OrderDetails.VolumetricWeight : a.OrderDetails.Weight;
    data.consignment.weight_measure = "Kgs";

    data.consignment.consignment_contents = {};
    data.consignment.consignment_contents.consignment_content = [];
    data.product_data = [];
    data.products = [];
    data.consignment_contents_common = {};
    data.consignment_contents_common.consignment_content_common = [];
    for (let k = 0; k < a.ProductDetails.length; k++) {
      var obj: any = {};

      obj.reference_number = a.OrderDetails.ReferenceNo; //ASK
      obj.delivery_number = null; //ASK
      obj.product_id = "";
      obj.product_name = 'OTHERS'; //a.ProductDetails[k].ProductName;
      obj.product_display_name = a.ProductDetails[k].ProductName;
      obj.units = a.ProductDetails[k].Qty;
      obj.unit_type = 'Units'; //a.ProductDetails[k].UnitName;
      obj.weight = a.ProductDetails[k].weight;
      obj.billable_weight = a.ProductDetails[k].VolumetricWeight > a.OrderDetails.Weight == true ? a.ProductDetails[k].VolumetricWeight : a.OrderDetails.Weight;
      obj.weight_measure = "Kgs";
      obj.length = a.ProductDetails[k].Length;
      obj.width = a.ProductDetails[k].Width;
      obj.height = a.ProductDetails[k].Height;
      obj.uom = 'inches'; //a.ProductDetails[k].UnitName;
      data.consignment.consignment_contents.consignment_content.push(obj);

      //************************************************************** */
      var obj2: any = {};
      obj2.hsnno = a.ProductDetails[k].HSNNo;
      obj2.product_name = a.ProductDetails[k].ProductName;

      var total = parseFloat(a.ProductDetails[k].Price) * parseFloat(a.ProductDetails[k].Qty);
      if (a.OrderDetails.ConsignerState == a.OrderDetails.ConsigneeState) {
        obj2.SGSTAmount = total * (9 / 100);
        obj2.CGSTAmount = total * (9 / 100);
        obj2.IGSTAmount = 0;
        obj2.GSTTaxRateCGSTN = 9;
        obj2.GSTTaxRateSGSTN = 9;
        obj2.GSTTAXRateIGSTN = 0;
      } else {
        obj2.SGSTAmount = 0;
        obj2.CGSTAmount = 0;
        obj2.IGSTAmount = total * (18 / 100);
        obj2.GSTTaxRateCGSTN = 0;
        obj2.GSTTaxRateSGSTN = 0;
        obj2.GSTTAXRateIGSTN = 18;
      }

      obj2.Discount = 0;
      obj2.GSTTaxTotal = (obj2.SGSTAmount + obj2.CGSTAmount + obj2.IGSTAmount);
      obj2.TaxableValue = total + obj2.GSTTaxTotal;
      data.product_data.push(obj2);

      //************************************************************** */
      var obj3: any = {};

      obj3.reference_number = a.OrderDetails.ReferenceNo; //ASK
      obj3.delivery_number = null; //ASK
      obj3.product_id = "";
      obj3.product_name = 'OTHERS'; //a.ProductDetails[k].ProductName;
      obj3.product_display_name = a.ProductDetails[k].ProductName;
      obj3.units = a.ProductDetails[k].Qty;
      obj3.unit_type = 'Units'; //a.ProductDetails[k].UnitName;
      obj3.weight = a.ProductDetails[k].ProductWeight;
      obj3.billable_weight = a.ProductDetails[k].VolumetricWeight > a.OrderDetails.Weight == true ? a.ProductDetails[k].VolumetricWeight : a.OrderDetails.Weight;
      obj3.weight_measure = "Kgs";
      obj3.length = a.ProductDetails[k].Length;
      obj3.width = a.ProductDetails[k].Width;
      obj3.height = a.ProductDetails[k].Height;
      obj3.uom = 'inches'; //a.ProductDetails[k].UnitName;
      obj3.hsnno = a.ProductDetails[k].HSNNo;
      obj3.price = a.ProductDetails[k].Price;
      var total = parseFloat(a.ProductDetails[k].Price) * parseFloat(a.ProductDetails[k].Qty);
      if (a.OrderDetails.ConsignerState == a.OrderDetails.ConsigneeState) {
        obj3.SGSTAmount = total * (9 / 100);
        obj3.CGSTAmount = total * (9 / 100);
        obj3.IGSTAmount = 0;
        obj3.GSTTaxRateCGSTN = 9;
        obj3.GSTTaxRateSGSTN = 9;
        obj3.GSTTAXRateIGSTN = 0;
      } else {
        obj3.SGSTAmount = 0;
        obj3.CGSTAmount = 0;
        obj3.IGSTAmount = total * (18 / 100);
        obj3.GSTTaxRateCGSTN = 0;
        obj3.GSTTaxRateSGSTN = 0;
        obj3.GSTTAXRateIGSTN = 18;
      }
      obj3.Discount = 0;
      obj3.GSTTaxTotal = (obj3.SGSTAmount + obj3.CGSTAmount + obj3.IGSTAmount);
      obj3.TaxableValue = total + obj3.GSTTaxTotal;
      data.products.push(obj3);

      var obj4: any = {};

      obj4.reference_number = a.OrderDetails.ReferenceNo; //ASK
      obj4.delivery_number = null; //ASK
      obj4.product_id = "";
      obj4.product_name = 'OTHERS'; //a.ProductDetails[k].ProductName;
      obj4.product_display_name = a.ProductDetails[k].ProductName;
      obj4.units = a.ProductDetails[k].Qty;
      obj4.unit_type = 'Units'; //a.ProductDetails[k].UnitName;
      obj4.weight = a.ProductDetails[k].weight;
      obj4.billable_weight = a.ProductDetails[k].VolumetricWeight > a.OrderDetails.Weight == true ? a.ProductDetails[k].VolumetricWeight : a.OrderDetails.Weight;
      obj4.weight_measure = "Kgs";
      obj4.length = a.ProductDetails[k].Length;
      obj4.width = a.ProductDetails[k].Width;
      obj4.height = a.ProductDetails[k].Height;
      obj4.uom = 'inches'; //a.ProductDetails[k].UnitName;
      obj4.Barcode = a.ProductDetails[k].Barcode;
      obj4.product_code = a.ProductDetails[k].ProductCode;
      obj4.Category = a.ProductDetails[k].Category;
      data.consignment_contents_common.consignment_content_common.push(obj4);
    }

    data.consignment.consignment_invoices = {};
    data.consignment.consignment_invoices.consignment_invoice = [];
    for (let k = 0; k < a.InvoiceDetails.length; k++) {
      var obj: any = {};

      obj.invoice_number = a.InvoiceDetails[k].InvoiceNo;
      obj.delivery_number = null; //ASK
      obj.invoice_value = a.InvoiceDetails[k].Amount;
      obj.invoice_date = a.InvoiceDetails[k].InvoiceDate;
      obj.cod_amount = a.InvoiceDetails[k].Amount;
      obj.weight = a.OrderDetails.Weight;
      obj.billable_weight = a.InvoiceDetails[k].VolumetricWeight > a.OrderDetails.Weight ? a.InvoiceDetails[k].VolumetricWeight : a.OrderDetails.Weight;
      obj.weight_measure = "Kgs";
      obj.pickable_units = a.InvoiceDetails[k].Qty;
      obj.eway_bill_number = a.InvoiceDetails[k].eWayBill;
      obj.eway_bill_expiry_date = a.InvoiceDetails[k].eWayBillExpiryDate;
      data.consignment.consignment_invoices.consignment_invoice.push(obj);
    }

    data.parcellist = [];
    for (let k = 0; k < a.OrdersPackage.length; k++) {
      var obj: any = {};
      obj.weight = a.OrdersPackage[k].GrossWeight;
      obj.length = a.OrdersPackage[k].Length;
      obj.height = a.OrdersPackage[k].Height;
      obj.width = a.OrdersPackage[k].Width;
      obj.item_description = a.OrdersPackage[k].ProductName;
      obj.no_of_items = a.OrdersPackage[k].TotalPackages;
      obj.item_value = a.OrdersPackage[k].InvoiceAmount;
      obj.hscode = a.OrdersPackage[k].HSNNo;
      data.parcellist.push(obj);
    }

    data.consignment.service_provider_id = "";
    data.consignment.service_provider_name = "";
    data.consignment.service_provider_code = "";
    data.consignment.consignment_type = "OUTBOUND-TBB";
    data.OrderId = OrderId;
    data.TransporterId = TransporterId;
    data.PickUpDateTime = a.OrderDetails.PickupDate;
    data.consignor_email = a.OrderDetails.PickUpContactEmail;
    data.consignee_email = a.OrderDetails.DeliveryContactEmail;
    data.consignor_lat = a.OrderDetails.PickUpLatitude;
    data.consignor_long = a.OrderDetails.PickUpLongtitude;
    data.consignee_lat = a.OrderDetails.DeliverLatitude;
    data.consignee_long = a.OrderDetails.DeliverLongtitude;
    data.tax_id = a.OrderDetails.PickupGSTNo;
    data.consignor_country = a.OrderDetails.PickupCountry;
    data.consignee_country = a.OrderDetails.DeliveryCountry;
    data.VolumetricWeight = a.OrderDetails.VolumetricWeight;
    data.PickupDateV2 = a.OrderDetails.PickupDateV2;

    data.Customer = {};
    data.Customer.CustomerAddress1 = a.OrderDetails.CustomerAddress;
    data.Customer.CustomerAddress2 = "";
    data.Customer.CustomerAddress3 = "";
    data.Customer.CustomerEmailID = a.OrderDetails.CustomerMail;
    data.Customer.CustomerGSTNumber = a.OrderDetails.CustomeGST;
    data.Customer.CustomerLatitude = "";
    data.Customer.CustomerLongitude = "";
    data.Customer.CustomerMobile = a.OrderDetails.CustomerMobile;
    data.Customer.CustomerName = a.OrderDetails.CustomerName;
    data.Customer.CustomerPincode = a.OrderDetails.CustomerPincode;
    data.service_code = service_code;

    Helpers.setLoading(true);
    await new Promise(async (resolve1, reject1) => {
      this._appService
        .Post("OrdersByVehicle", "CreateConsignment", data)
        .subscribe(
          async (response) => {
            Helpers.setLoading(false);

            if (response.isScuccess == true) {
              this.toastr.success(
                this.translate.instant("ALERTMESSAGES.ConsignmentSuccess"),
                "Success"
              );

              var ShipmentId, ShipmentNo = '';
              if (TransporterName == "Smart Track") {
                var msg = JSON.parse(response.message);
                ShipmentId = msg['data']['shipment_id'];
                ShipmentNo = msg['data']['shipment_number'];
              }

              Helpers.setLoading(true);
              this._appService
                .GetByEightId(
                  "OrdersByVehicle",
                  "oc_ConfirmCourierData_generateInvoiceOrderWiseV2",
                  OrderId,
                  this.userId,
                  TransporterId,
                  LeadTime,
                  ShipmentId,
                  ShipmentNo,
                  service_code,
                  TotalRate
                )
                .subscribe(
                  async (response) => {
                    Helpers.setLoading(false);
                    if (response[0].isDone == "OK") {
                      this.toastr.success(
                        "Order Confirm successfully !",
                        "Success"
                      );

                      resolve1("Ok");
                      setTimeout(() => {
                        if (this.TransationType == "Air") {
                          window.location.href = '/NewBookingList';
                          // this.router.navigateByUrl(`/NewBookingList`);
                        } else {
                          this.router.navigateByUrl(`/FtlList`);
                        }
                      }, 1000);
                      Helpers.setLoading(false);
                    } else {
                      this.toastr.success(
                        "Error Occurred While ConFirm Booking !",
                        "Error"
                      );
                      Helpers.setLoading(false);
                      resolve1("Ok");
                    }
                    if (response[0].invoiceResult != "Success") {
                      this.toastr.success(
                        "Error Occurred While Generating Shipment !",
                        "Error"
                      );
                      Helpers.setLoading(false);
                      resolve1("Ok");
                    }
                  },
                  (err) => {
                    Helpers.setLoading(false);
                    this.toastr.error(err._body.replace(/"/g, ""), "Error");
                    resolve1("Ok");
                  }
                );
            } else {
              var msg = JSON.parse(response.message);

              if (TransporterName == "V-Xpress")
                this.toastr.error(msg.exception.message, "Error");

              if (
                TransporterName == "Delhivery" ||
                TransporterName == "OM Logistics"
              )
                this.toastr.error(msg.message, "Error");

              if (TransporterName == "XpressBees")
                this.toastr.error(msg.ReturnMessage, "Error");

              if (TransporterName == "Allcargo GATI") {
                // this.toastr.error(msg['meta']['message'], 'Error');
                const detailsArray = msg["meta"]["details"][0];
                if (!detailsArray.includes("{")) {
                  this.toastr.error(detailsArray, "Error", {
                    enableHtml: true,
                  });
                } else {
                  const validJsonString = detailsArray.replace(/'/g, '"');
                  const detailsObject = JSON.parse(validJsonString);
                  let toastrMessage = "";

                  // Loop through details and format message
                  for (const key in detailsObject) {
                    if (detailsObject.hasOwnProperty(key)) {
                      const nestedObject = detailsObject[key];
                      for (const nestedKey in nestedObject) {
                        if (nestedObject.hasOwnProperty(nestedKey)) {
                          const errors = nestedObject[nestedKey];
                          if (Array.isArray(errors)) {
                            // If errors is an array, iterate over each error
                            errors.forEach((error: string) => {
                              toastrMessage += `${nestedKey}: ${error}<br>`;
                            });
                          } else if (typeof errors === "object") {
                            // If errors is an object, assume it has message arrays
                            for (const prop in errors) {
                              if (
                                errors.hasOwnProperty(prop) &&
                                Array.isArray(errors[prop])
                              ) {
                                errors[prop].forEach((error: string) => {
                                  toastrMessage += `${prop}: ${error}<br>`;
                                });
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                  // Show toastr message
                  this.toastr.error(toastrMessage, "Error", {
                    enableHtml: true,
                  });
                }
              }

              if (TransporterName == 'Smart Track') {
                this.toastr.error(msg.errors[0], 'Error');
              }

              Helpers.setLoading(false);
            }
          },
          (err) => {
            // this.toastr.error(err._body.replace(/"/g, ""), "Error");
            Helpers.setLoading(false);
          }
        );
    });
  }

  OnSaveAssignVehicle(event) {
    this.IsAssignvehicleSaveDisable = true;
    var obj: any = {};
    obj = event;
    const estimatedDate = new Date(obj.EstimatedDeliveryDate);
    const placementDate = new Date(obj.VehiclePlacementDate);
    if (estimatedDate <= placementDate && estimatedDate != placementDate) {
      this.toastr.error(this.translate.instant("PENDINGARRIVAL.PlacementDateValidation"), "Alert");
      this.IsAssignvehicleSaveDisable = false;
      return;
    }
    // if (obj.EstimatedDeliveryDate <= obj.VehiclePlacementDate && obj.EstimatedDeliveryDate != obj.VehiclePlacementDate) {
    //   this.toastr.error(this.translate.instant("PENDINGARRIVAL.PlacementDateValidation"), "Alert");
    //   this.IsAssignvehicleSaveDisable = false;
    //   return;
    // }
    if (this.ValidateTHCADvanceAmountFlag == true) {
      if (obj.Advance == 0 || obj.Advance == undefined || obj.Advance == null || obj.Advance == "") {
        var message = this.translate.instant("ALERTMESSAGES.AdvanceAmountShoubeGraterThanZero");
        this.toastr.error(message, "Alert");
        this.IsAssignvehicleSaveDisable = false;
        return;
      }
    }

    this.ManualvehicleOrderList = this.CourierList;
    var FinalDestination = this.ManualvehicleOrderList[0].DeliveryLocationCode;
    this._appService.GetByTwoId("Booking", "GetOrderAddressFromLocationCode", null, FinalDestination).subscribe(async (response) => {
      var DestinationLocation = "";
      DestinationLocation = response[0].DeliveryAddress;
      var DeliveryAddressUnique: any = [];
      var OrderInfo: any = [];
      var obj1: any = {};
      (obj1.origin = this.ManualvehicleOrderList[0].PickupAddress), (obj1.destination = response[0].DeliveryAddress);
      OrderInfo.push(obj1);

      this.ManualvehicleOrderList.map(function (item) {
        if (SelfFulfilledComponent.that.ManualPlanningDestinationValuesFromPinCodeDeliveryBranchFlag == true) {
          item.DeliveryAddress = response[0].DeliveryAddress;
        }
        var existItem = DeliveryAddressUnique.find((x) => x.location == item.DeliveryAddress);
        if (!existItem) {
          var obj: any = {};
          (obj.location = item.DeliveryAddress),
            (obj.stopover = true),
            (obj.Order = 0),
            (obj.RouteOrder = "A");
          DeliveryAddressUnique.push(obj);
        }
      });

      var DeliveryAddressUniqueResult: any = [];
      SelfFulfilledComponent.that.calculateRouteOptimization(OrderInfo, DeliveryAddressUnique).then(async (res) => {
        setTimeout(() => {
          DeliveryAddressUniqueResult = res;
          for (let i = 0; i < this.ManualvehicleOrderList.length; i++) {
            for (let j = 0; j < DeliveryAddressUniqueResult.length; j++) {
              if (
                this.ManualvehicleOrderList[i].DeliveryAddress ==
                DeliveryAddressUniqueResult[j].location
              ) {
                this.ManualvehicleOrderList[i].RouteOrder =
                  DeliveryAddressUniqueResult[j].RouteOrder;
              }
            }
          }

          for (let i = 0; i < this.ManualvehicleOrderList.length; i++) {
            this.ManualvehicleOrderDetail[i] = {};
            this.ManualvehicleOrderDetail[i].OrderID = this.ManualvehicleOrderList[i].Id;
            this.ManualvehicleOrderDetail[i].PickupLocationCode = this.ManualvehicleOrderList[i].PickupLocationCode;
            this.ManualvehicleOrderDetail[i].DeliveryLocationCode = FinalDestination;
            if (this.isSTPBooking) {
              this.ManualvehicleOrderDetail[i].DeliveryLocationCode = this.ManualvehicleOrderList[i].DeliveryLocationCode;
            }
            this.ManualvehicleOrderDetail[i].Qty = this.ManualvehicleOrderList[i].Qty;
            this.ManualvehicleOrderDetail[i].OrderItemsId = this.ManualvehicleOrderList[i].OrderItemsId == undefined ? null : this.ManualvehicleOrderList[i].OrderItemsId;
            this.ManualvehicleOrderDetail[i].VehicleOrdersProductID = this.ManualvehicleOrderList[i].VehicleOrdersProductID == undefined ? null : this.ManualvehicleOrderList[i].VehicleOrdersProductID;
            this.ManualvehicleOrderDetail[i].RouteOrder = this.ManualvehicleOrderList[i].RouteOrder;
          }

          this.ManualvehiclePlanning.ManualvehicleOrderDetail = this.ManualvehicleOrderDetail;
          this.ManualvehiclePlanning.TransportServiceId = obj.TransportService;
          this.ManualvehiclePlanning.TransporterId = obj.Transporter;
          this.ManualvehiclePlanning.VehicleTypeID = obj.VehicleType;
          this.ManualvehiclePlanning.VehicleNo = obj.VehicleNo;
          this.ManualvehiclePlanning.DriverCode = obj.Driver;
          this.ManualvehiclePlanning.DriverMobileNo = obj.DriverMobileNo;
          this.ManualvehiclePlanning.VehiclePlacementDate = obj.VehiclePlacementDate;
          this.ManualvehiclePlanning.EstimatedDeliveryDate = obj.EstimatedDeliveryDate;
          this.ManualvehiclePlanning.BookingType = "primary"; //this.BookingType;
          this.ManualvehiclePlanning.BookingTypeAuto = null;
          this.ManualvehiclePlanning.LeadTime = obj.LeadTime;
          this.ManualvehiclePlanning.Advance = obj.Advance;
          // if (this.isSTPBooking) {
          //   this.ManualvehiclePlanning.BookingTypeAuto = this.STPModelListData[this.STPIdexId].BookingType;
          // }
          this.ManualvehiclePlanning.CompanyId = this.CompanyId;
          this.ManualvehiclePlanning.opa_userId = this.userId;
          this.ManualvehiclePlanning.Captain = null;
          this.ManualvehiclePlanning.IsFromRouteOptimization = false;
          this.ManualvehiclePlanning.RouteOptimization = true;
          this.ManualvehiclePlanning.PotterTripId = null;
          this.ManualvehiclePlanning.ChargeAmount = 0;
          this.ManualvehiclePlanning.IsFromManualPlanning = false;
          //added by vithu 07-04-2025
          this.ManualvehiclePlanning.IsAutomateRecordIncomeConsignmentWise = false;
          this.ManualvehiclePlanning.IsAutomateTripExpense = true;

          SelfFulfilledComponent.that._appService.Post("ManualvehiclePlanning", "CreateBookingFromManualPlan", SelfFulfilledComponent.that.ManualvehiclePlanning).subscribe((response) => {
            this.IsAssignvehicleSaveDisable = false;
            if (response == true) {
              SelfFulfilledComponent.that.toastr.success("Booking Created Successfully !", "Success");
              SelfFulfilledComponent.that.modalRef.close();
              if (this.TransationType == 'FTL') {
                SelfFulfilledComponent.that.router.navigateByUrl(`/FtlList`);
              } else if (this.TransationType == 'ContainerMovement') {
                SelfFulfilledComponent.that.router.navigateByUrl(`/Container-Movement`);
              } else {
                SelfFulfilledComponent.that.router.navigateByUrl(`/FtlList`);
              }
            }
          },
            (err) => {
              SelfFulfilledComponent.that.toastr.error(err._body.replace(/"/g, ""), "Error");
              this.IsAssignvehicleSaveDisable = false;
            }
          );
        }, 2000);
      });
    },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
        this.IsAssignvehicleSaveDisable = false;
      }
    );
  }

  async calculateRouteOptimization(
    OrderInfoData,
    DestinationLocation
  ): Promise<Observable<any>> {
    try {
      if (DestinationLocation.length > 1) {
        const directionsService = new google.maps.DirectionsService();
        const waypts = [];
        for (let i = 0; i < DestinationLocation.length; i++) {
          waypts.push({
            location: DestinationLocation[i].location,
            stopover: true,
          });
        }
        await directionsService.route(
          {
            origin: OrderInfoData[0].origin,
            destination: OrderInfoData[0].destination,
            waypoints: waypts,
            optimizeWaypoints: true,
            travelMode: google.maps.TravelMode.DRIVING,
          },
          (response, status) => {
            if (status === "OK") {
              let ViewPoints = [];
              ViewPoints = response.routes[0].waypoint_order;
              var mainNum = 65;
              var subNum = 63;
              for (let i = 0; i < ViewPoints.length; i++) {
                DestinationLocation[ViewPoints[i]].Order = i;
                DestinationLocation[ViewPoints[i]].RouteOrder =
                  subNum == 63
                    ? String.fromCharCode(mainNum)
                    : String.fromCharCode(mainNum) +
                    String.fromCharCode(subNum);
                if (mainNum == 90 || subNum == 90) {
                  mainNum = subNum == 63 ? 65 : mainNum + 1;
                  subNum = 64;
                }
                subNum = subNum == 63 ? subNum : subNum + 1;
                mainNum = subNum == 63 ? mainNum + 1 : mainNum;
              }
              // this.OrderDestinationLocation1=(DestinationLocation);
              // return this.OrderDestinationLocation1;
            } else {
              // window.alert("Directions request failed due to " + status);
            }
          }
        );
      }
    } catch (error) {
      return DestinationLocation;
    }
    return DestinationLocation;
  }

  GetSelectedVehicleInfo(data) {
    this.singleVehicle = [];
    this.singleVehicle.push(data);
    if (this.PickUpLatitude == null || this.PickUpLongtitude == null)
      this.getLatLng(data.PickupAddress, "Origin");
    if (this.DeliverLatitude == null || this.DeliverLongtitude == null)
      this.getLatLng(data.DeliveryAddress, "Destination");
  }

  getLatLng(address: string, from: string) {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address: address }, (results, status) => {
      if (status === "OK") {
        const location = results[0].geometry.location;
        if (from === "Origin") {
          this.PickUpLatitude = location.lat();
          this.PickUpLongtitude = location.lng();
        }
        if (from === "Destination") {
          this.DeliverLatitude = location.lat();
          this.DeliverLongtitude = location.lng();
        }
      } else {
        console.log("Geocode was not successful for the following reason: " + status);
      }
    });
  }

  // async initializeMap(): Promise<void> {
  //   this.mapPickup = new google.maps.Map(document.getElementById("SelfFullfieldMap"), {
  //     zoom: 5,
  //     center: { lat: 28.644800, lng: 77.216721 },
  //     mapTypeControl: true,
  //     mapTypeControlOptions: {
  //       position: google.maps.ControlPosition.TOP_RIGHT,
  //     },
  //     gestureHandling: "auto",
  //     scrollwheel: true,
  //   });

  //   this.infoWindow = new google.maps.InfoWindow({ content: "", disableAutoPan: true });

  //   const labels = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  //   const batchSize = 2000;

  //   // Clear existing markers
  //   if (this.beachMarker && this.beachMarker.length > 0) {
  //     this.beachMarker.forEach(marker => marker.setMap(null));
  //   }
  //   this.beachMarker = [];

  //   // Function to add markers in batches
  //   const addMarkersBatch = async (start, end) => {
  //     for (let i = start; i < end; i++) {
  //       const position = this.tableData[i];
  //       if (!position || position.lat == null || position.long == null) {
  //         //console.log(`Invalid coordinates at index ${i}:`, position);
  //         continue;
  //       }

  //       const label = labels[i % labels.length];
  //       let image = '';

  //       // Set vehicle status image based on status
  //       if (position.Status === 'Idle') {
  //         image = "../../../assets/img/Truck_Green.svg";
  //       } else if (position.Status === 'inactive') {
  //         image = "../../../assets/img/Truck_Purple.svg";
  //       } else if (position.Status === 'Repair') {
  //         image = "../../../assets/img/Truck_Red.svg";
  //       } else if (position.Status === 'running') {
  //         image = "../../../assets/img/Truck_idle.svg";
  //       } else if (position.Status === 'nodata') {
  //         image = "../../../assets/img/Truck_no_Data.svg";
  //       } else {
  //         image = "../../../assets/img/Truck_Purple.svg";
  //       }

  //       const latlng = { lat: position.lat, lng: position.long };
  //       const marker = new google.maps.Marker({
  //         position: latlng,
  //         title: position.RegistrationNo + ' - ' + position.VehicleType,
  //         icon: image, // Set the custom icon based on status
  //         map: this.mapPickup
  //       });

  //       // Marker click listener to show InfoWindow
  //       marker.addListener("click", () => {
  //         this.showInfoWindow(marker, position);
  //       });

  //       this.beachMarker.push(marker);
  //     }
  //     await new Promise(resolve => setTimeout(resolve, 0));
  //   };

  //   // Load vehicle markers in batches
  //   let i = 0;
  //   for (const item of this.tableData) {
  //     if (i < this.tableData.length) {
  //       await addMarkersBatch(i, Math.min(i + batchSize, this.tableData.length));
  //       i += batchSize;
  //     } else {
  //       break;
  //     }
  //   }

  //   // If MarkerClusterer is available, apply it
  //   // if (typeof MarkerClusterer !== "undefined") {
  //   //   const markerCluster = new MarkerClusterer({
  //   //     map: this.mapPickup,
  //   //     markers: this.beachMarker,
  //   //     algorithm: new SuperClusterAlgorithm({ minPoints: 1 }),
  //   //   });
  //   // } else {
  //   //   console.error("MarkerClusterer is not available.");
  //   // }

  //   const directionsService = new google.maps.DirectionsService();
  //   const directionsRenderer = new google.maps.DirectionsRenderer({
  //     map: this.mapPickup,
  //   });

  //   const pickupLocation = this.ordersData.Pickupcitycountry;
  //   const deliveryLocation = this.ordersData.Deliverycitycountry;
  //   const startingPoint = this.ordersData.CFSYardCity;

  //   if (this.TransationType === 'FTL') {
  //     // Route for Full Truck Load (FTL)
  //     directionsService.route(
  //       {
  //         origin: pickupLocation,
  //         destination: deliveryLocation,
  //         travelMode: google.maps.TravelMode.DRIVING,
  //       },
  //       (response, status) => {
  //         if (status === google.maps.DirectionsStatus.OK) {
  //           directionsRenderer.setDirections(response);
  //         } else {
  //           console.error("Directions request failed due to " + status);
  //         }
  //       }
  //     );
  //   } else if (this.TransationType === 'ContainerMovement') {
  //     // Route for Container Movement
  //     const waypoints = startingPoint ? [{ location: startingPoint, stopover: true }] : [];

  //     directionsService.route(
  //       {
  //         origin: startingPoint, // Start from Starting Point
  //         destination: deliveryLocation, // End at Delivery Location
  //         waypoints: [{ location: pickupLocation, stopover: true }], // Pass through Pickup Location
  //         travelMode: google.maps.TravelMode.DRIVING,
  //       },
  //       (response, status) => {
  //         if (status === google.maps.DirectionsStatus.OK) {
  //           directionsRenderer.setDirections(response);
  //         } else {
  //           console.error("Directions request failed due to " + status);
  //         }
  //       }
  //     );
  //   }



  //   // const pickupLocation = this.ordersData.Pickupcitycountry;
  //   // const deliveryLocation = this.ordersData.Deliverycitycountry;
  //   // const StartingPoint = this.ordersData.CFSYardCity;

  //   // directionsService.route(
  //   //   {
  //   //     origin: pickupLocation,
  //   //     destination: deliveryLocation,
  //   //     travelMode: google.maps.TravelMode.DRIVING,
  //   //   },
  //   //   (response, status) => {
  //   //     if (status === google.maps.DirectionsStatus.OK) {
  //   //       directionsRenderer.setDirections(response);
  //   //     } else {
  //   //       console.error("Directions request failed due to " + status);
  //   //     }
  //   //   }
  //   // );

  //   setTimeout(() => {
  //     Helpers.setLoading(false);
  //   }, 500);
  // }

  InitMapSelfFullFilled() {
    const containerEl = this.mapContainerSelfFullfilled.nativeElement;
    var initialCoords = null;
    initialCoords = [18.9836681, 73.0525676] as L.LatLngExpression;

    if (this.mapSelfFullfilled) {
      this.mapSelfFullfilled.remove();
    }

    this.mapSelfFullfilled = L.map(containerEl).setView(initialCoords, 7);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(this.mapSelfFullfilled);

    setTimeout(() => this.mapSelfFullfilled.invalidateSize(), 200);
    setTimeout(() => this.mapSelfFullfilled.invalidateSize(), 1000);
  }

  ngAfterViewInit(): void {
    // if (this.mapContainerSelfFullfilled && !this.mapSelfFullfilled) {
      // this.InitMapSelfFullFilled();
      // this.getMapRadius();
    // }
  }

  private originMarker: L.Marker;
  private destMarker: L.Marker;
  private cfsMarker: L.Marker;
  private routingControl: any;
  originCircle: any;
  destCircle: any;
  cfsCircle: any;
  mapRadius: any = 0;
  WayPoints: any = [];
  getMapRadius() {
    this._appService
      .Get(
        "OrdersByVehicle",
        "getMapRadius"
      )
      .subscribe(
        (response) => {
          this.mapRadius = response;
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "Error");
        }
      );
  }

  async showOriginDestinationWayPoint(): Promise<void> {
    try {
      const that = SelfFulfilledComponent.that;

      const originCoords = [this.tableData[0].PickUpLatitude, this.tableData[0].PickUpLongtitude] as L.LatLngExpression;
      const destCoords = [this.tableData[0].DeliverLatitude, this.tableData[0].DeliverLongtitude] as L.LatLngExpression;
      const cfsCoords = [this.tableData[0].CFSLattitute, this.tableData[0].CFSLongitute] as L.LatLngExpression;

      // Initialize map
      if (!this.mapSelfFullfilled) {
        this.mapSelfFullfilled = L.map('Newmap').setView(originCoords, 7);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; OpenStreetMap contributors'
        }).addTo(this.mapSelfFullfilled);
      }

      // Cleanup previous layers
      [this.originMarker, this.destMarker, this.originCircle, this.destCircle, this.routingControl, this.cfsMarker, this.cfsCircle]
        .forEach(layer => {
          if (layer) this.mapSelfFullfilled.removeLayer(layer);
        });

      // Origin marker
      this.originMarker = L.marker(originCoords, { icon: this.originIcon })
        .addTo(this.mapSelfFullfilled)
        .bindPopup(`<b>Origin:</b><br>${that.tableData[0].PickupAddress}`);

      this.originCircle = L.circle(originCoords, {
        radius: this.mapRadius, color: '#00bfff', fillColor: '#00bfff', weight: 1, fillOpacity: 0.2
      }).addTo(this.mapSelfFullfilled);

      // Destination marker
      this.destMarker = L.marker(destCoords, { icon: this.destinationIcon })
        .addTo(this.mapSelfFullfilled)
        .bindPopup(`<b>Destination:</b><br>${that.tableData[0].DeliveryAddress}`);

      this.destCircle = L.circle(destCoords, {
        radius: this.mapRadius, color: '#ff5733', fillColor: '#ff5733', weight: 1, fillOpacity: 0.2
      }).addTo(this.mapSelfFullfilled);

      // If ContainerMovement, add CFS
      let routingWaypoints: L.LatLng[] = [];
      if (this.TransationType === 'ContainerMovement') {
        this.cfsMarker = L.marker(cfsCoords, { icon: this.cfsIcon })
          .addTo(this.mapSelfFullfilled)
          .bindPopup(`<b>CFS:</b><br>${that.tableData[0].ContainerPickupAddress}`);

        this.cfsCircle = L.circle(cfsCoords, {
          radius: this.mapRadius, color: '#FFA500', fillColor: '#FFA500', weight: 1, fillOpacity: 0.2
        }).addTo(this.mapSelfFullfilled);

        routingWaypoints.push(L.latLng(cfsCoords[0], cfsCoords[1]));
      }

      routingWaypoints.push(L.latLng(originCoords[0], originCoords[1]));

      // Add dynamic waypoints
      const midPoints = this.WayPoints
        .filter(wp => wp.lat && wp.lng && !isNaN(wp.lat) && !isNaN(wp.lng))
        .map(wp => L.latLng(wp.lat, wp.lng));

      routingWaypoints = routingWaypoints.concat(midPoints);
      routingWaypoints.push(L.latLng(destCoords[0], destCoords[1]));

      // Routing control
      // @ts-ignore
      this.routingControl = L.Routing.control({
        waypoints: routingWaypoints,
        routeWhileDragging: false,
        addWaypoints: true,
        draggableWaypoints: false,
        show: true,
        lineOptions: {
          styles: [{ color: '#3b67fb', weight: 4, opacity: 0.8 }]
        },
        createMarker: (i, wp, n) => {
          if (this.TransationType === 'ContainerMovement') {
            if (i === 0) {
              return L.marker(wp.latLng, { icon: that.cfsIcon })
                .bindPopup(`<b>CFS</b><br>${that.tableData[0].ContainerPickupAddress}`);
            } else if (i === 1) {
              return L.marker(wp.latLng, { icon: that.originIcon })
                .bindPopup(`<b>Origin</b><br>${that.tableData[0].PickupAddress}`);
            } else if (i === n - 1) {
              return L.marker(wp.latLng, { icon: that.destinationIcon })
                .bindPopup(`<b>Destination</b><br>${that.tableData[0].DeliveryAddress}`);
            } else {
              const wpData = that.WayPoints[i - 2]; // offset due to CFS and Origin
              return L.marker(wp.latLng, { icon: that.waypointIcon })
                .bindPopup(`<b>Vehicle No</b><br>Vehicle No: ${wpData.VehicleNo || 'N/A'}`);
            }
          } else {
            if (i === 0) {
              return L.marker(wp.latLng, { icon: that.originIcon })
                .bindPopup(`<b>Origin</b><br>${that.tableData[0].PickupAddress}`);
            } else if (i === n - 1) {
              return L.marker(wp.latLng, { icon: that.destinationIcon })
                .bindPopup(`<b>Destination</b><br>${that.tableData[0].DeliveryAddress}`);
            } else {
              const wpData = that.WayPoints[i - 1];
              return L.marker(wp.latLng, { icon: that.waypointIcon })
                .bindPopup(`<b>Vehicle No</b><br>Vehicle No: ${wpData.VehicleNo || 'N/A'}`);
            }
          }
        },
        // Optional: hide boring instructions
        // @ts-ignore
        formatter: new L.Routing.Formatter({
          formatInstruction: (text) => {
            if (
              text.startsWith('Continue onto') ||
              text.startsWith('Exit the traffic circle') ||
              text.startsWith('Enter the traffic circle')
            ) return '';
            return text;
          }
        })
      }).addTo(this.mapSelfFullfilled);

      // ✅ Fit map to include all markers
      const allCoords: L.LatLngExpression[] = [
        originCoords,
        destCoords,
        ...(this.TransationType === 'ContainerMovement' ? [cfsCoords] : []),
        ...midPoints.map(mp => [mp.lat, mp.lng] as L.LatLngTuple)
      ];

      const bounds = L.latLngBounds(allCoords);
      this.mapSelfFullfilled.fitBounds(bounds, { padding: [50, 50] });

      // Optional: refine zoom after bounds fit
      setTimeout(() => this.mapSelfFullfilled.invalidateSize(), 200);
      setTimeout(() => this.mapSelfFullfilled.invalidateSize(), 1000);
      //setTimeout(() => this.mapSelfFullfilled.setZoom(8), 1000);
    } catch (error) {
      console.error('Error showing origin/destination:', error);
    }
  }


  showInfoWindow(marker: any, position: any) {
    // Close any existing InfoWindow before opening a new one
    if (this.infoWindow) {
      this.infoWindow.close();
    }

    let color = '';
    if (position.Status === 'Idle') {
      color = '#4bb543';
    } else if (position.Status === 'inactive') {
      color = '#8434f4';
    } else if (position.Status === 'Repair') {
      color = '#f13637';
    } else if (position.Status === 'running') {
      color = '#f3bb1b';
    } else if (position.Status === 'nodata') {
      color = '#313131';
    } else {
      color = '#8434f4';
    }

    const contentString = `
      <div style="padding:15px; background-color: ${color}; color: white;">
      <table style="table-layout: fixed;">
        <tr>
          <td style="color: white;">${position.RegistrationNo} - ${position.VehicleType}</td>
        </tr>
        <tr>
          <td style="color: white;">Driver: ${position.DriverName || 'N/A'}</td>
        </tr>
        <tr>
          <td style="color: white;">Status: ${position.Status}</td>
        </tr>
        <tr>
          <td style="color: white;">Tracked By: ${position.TrackedBy}</td>
        </tr>
      </table>
      </div>
    `;

    // Open the InfoWindow with the vehicle data
    if (this.infoWindow) {
      this.infoWindow.setContent(contentString);
      this.infoWindow.open(marker.getMap(), marker);
    }
  }

  openInfoWindowForVehicle(vehicleId: string) {
    const vehicle = this.tableData.find(item => item.id === vehicleId);
    if (vehicle) {
      const marker = this.beachMarker.find(marker => marker.title.includes(vehicle.RegistrationNo));
      if (marker) {
        // Show the InfoWindow
        this.showInfoWindow(marker, vehicle);

        // Smoothly pan to the marker's position
        if (this.mapPickup) {
          this.mapPickup.panTo(marker.getPosition());

          // Gradually zoom in
          const targetZoom = 10; // Desired zoom level
          const currentZoom = this.mapPickup.getZoom();
          const zoomSteps = targetZoom - currentZoom; // Number of zoom steps
          const stepDuration = 120; // Time between zoom steps in milliseconds

          if (zoomSteps > 0) {
            for (let i = 1; i <= zoomSteps; i++) {
              setTimeout(() => {
                this.mapPickup.setZoom(currentZoom + i);
              }, i * stepDuration);
            }
          } else if (zoomSteps < 0) {
            for (let i = 1; i <= Math.abs(zoomSteps); i++) {
              setTimeout(() => {
                this.mapPickup.setZoom(currentZoom - i);
              }, i * stepDuration);
            }
          }
        }
      }
    }
  }

  //added by vithu 03-04-2025
  GetExpenseBifurcation(OwnerId: any) {
    this.ExpenseBifurcation = [];
    this.modalRef = this.modalService.open(this.ExpenseBifurcationComponent);
    Helpers.setLoading(true)
    this._appService.GetByThreeId('OrdersByVehicle', 'GetExpenseBifurcationForSelf', this.ordersData.Id, OwnerId, null).subscribe(
      (response) => {
        this.ExpenseBifurcation = response;
        Helpers.setLoading(false)
      },
      (err) => {
        this.toastr.error("Error occurred while fetching data !", "error");
        Helpers.setLoading(false)
      }
    );
  }

}
